import { render, staticRenderFns } from "./Xtghd.vue?vue&type=template&id=241b52f4&scoped=true&"
import script from "./Xtghd.vue?vue&type=script&lang=js&"
export * from "./Xtghd.vue?vue&type=script&lang=js&"
import style0 from "./Xtghd.vue?vue&type=style&index=0&id=241b52f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241b52f4",
  null
  
)

export default component.exports